import CTAButton from "../Button";
import "./index.css";

function Banner() {
  return (
    <section className="main-banner">
      <div className="main-banner__grid" aria-hidden="true" />
      <div className="main-banner__glow" aria-hidden="true" />

      <div className="site-container main-banner__content">
        <p className="main-banner__eyebrow">Software Engineer</p>
        <h1 className="main-banner__title">Vanessa Martin</h1>
        <p className="main-banner__tagline">
          I build SaaS front-ends and backend systems that scale in
          production.
        </p>

        <div className="main-banner__actions">
          <CTAButton
            text="View my work"
            link="/work"
            className="main-banner__cta"
          />
        </div>
      </div>
    </section>
  );
}

export default Banner;
